module.exports = __webpack_public_path__ + "img/payment_active.2e23208b.svg";